import { Tooltip, Typography, TypographyVariant } from "@mui/material";
import { TaskParent } from "../../../app/backendTypes";
import UserSpanLoader from "../users/UserSpanLoader";

function ParentSpan(props: {
  parent: TaskParent;
  variant?: TypographyVariant;
}) {
  const { parent, variant } = props;

  let comp = <></>;

  switch (parent.kind) {
    case "User": {
      comp = <UserSpanLoader id={parent.inner.id} variant={variant} />;
      break;
    }

    case "Schedule": {
      comp = (
        <Typography
          component="span"
          variant={variant}
          style={{
            fontWeight: "bold",
            fontStyle: "italic",
          }}
        >
          Schedule ({parent.inner.kind})
        </Typography>
      );

      break;
    }

    case "VomHook": {
      comp = (
        <Tooltip
          arrow
          placement="top"
          title={
            <>
              Event Type: {parent.inner.event_type}
              <br />
              Not Id: {parent.inner.notification_id}
              <br />
              Msg Id: {parent.inner.message_id}
              <br />
              Sub Id: {parent.inner.subscription_id}
            </>
          }
        >
          <Typography
            component="span"
            variant={variant}
            style={{
              fontWeight: "bold",
              fontStyle: "italic",
            }}
          >
            VOM Hook
          </Typography>
        </Tooltip>
      );

      break;
    }

    default: {
      comp = (
        <Typography
          component="span"
          variant={variant}
          style={{
            fontWeight: "bold",
            fontStyle: "italic",
          }}
        >
          Unknown
        </Typography>
      );
    }
  }

  return comp;
}

export default ParentSpan;
